import { NumberFormatter } from 'components/shared/NumberFormatter/NumberFormatter';
import { IndependentAmount, IndependentAmountType } from 'models/forms/TradeAllocationFormResult';
import { FC } from 'react';

export interface IndependentAmountFieldProps {
  independentAmount: IndependentAmount;
  currency: string;
  isDisabled: boolean;
  index: number;
  onIndependentAmountChanged: (independentAmount: IndependentAmount) => void;
}

const resetAmountField = (type: IndependentAmountType, ia: IndependentAmount): IndependentAmount => ({
  ...ia,
  type,
  ...(type === 'Percentage' ? { amount: null } : { percentageAmount: null }),
});

export const IndependentAmountField: FC<IndependentAmountFieldProps> = ({
  independentAmount,
  currency,
  isDisabled,
  index,
  onIndependentAmountChanged,
}) => {
  const currentType = independentAmount.type ?? 'Percentage';
  const hasPercentageAmountError = currentType === 'Percentage' && independentAmount.percentageAmount === null;
  const hasAmountError = currentType === 'Notional' && independentAmount.amount === null;
  const currentValue = currentType === 'Percentage' ? independentAmount.percentageAmount : independentAmount.amount;
  const hasError = currentType === 'Percentage' ? hasPercentageAmountError : hasAmountError;

  const onUnitChange = (value: IndependentAmountType) => {
    onIndependentAmountChanged(resetAmountField(value, independentAmount));
  };

  return (
    <>
      <div className="flex-grow-1">
        <NumberFormatter
          className="text-start"
          isDisabled={isDisabled}
          e2e="tradeAllocation-ia-value"
          value={currentValue}
          hasError={hasError}
          onNullableChange={value =>
            onIndependentAmountChanged({
              ...independentAmount,
              ...(currentType === 'Percentage' ? { percentageAmount: value ?? null } : { amount: value ?? null }),
            })
          }
          precision={4}
          decimalPadding={false}
        />
      </div>
      <div className="flex-shrink-0 w-auto">
        <select
          className="form-select form-control-sm w-auto"
          id={`tradeAllocation-ia-unit-${index}`}
          value={currentType}
          disabled={isDisabled}
          data-e2e="tradeAllocation-ia-unit"
          onChange={event => onUnitChange(event.target.value as IndependentAmountType)}
        >
          <option value="Notional">{currency}</option>
          <option value="Percentage">%</option>
        </select>
      </div>
    </>
  );
};
